import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, CheckCircle2, Instagram, MessageCircle, Navigation } from 'lucide-react';
export function Branches() {
  const whatsappVGG = 'https://wa.me/5493417453398?text=Hola%2C+quiero+consultar+por+una+reserva+en+El+Matambrito+VGG+🍖';
  const whatsappRosario = 'https://wa.me/5493417453398?text=Hola%2C+quiero+consultar+por+El+Matambrito+Rosario+🍖';
  return <section id="sucursales" className="py-24 bg-matambrito-charcoal relative" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-44">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-matambrito-cream mb-4" data-id="element-45">
            Encontranos{' '}
            <span className="text-matambrito-gold" data-id="element-46">donde estés</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start" data-id="element-47">
          {/* Main Branch - VGG */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-2 bg-matambrito-black rounded-2xl p-8 md:p-10 border-2 border-matambrito-red-dark relative overflow-hidden shadow-2xl" data-id="element-48">
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-matambrito-red-dark/10 rounded-full blur-3xl pointer-events-none" data-id="element-49"></div>

            <div className="relative z-10" data-id="element-50">
              {/* Branch hero image */}
              <div className="aspect-[16/9] lg:aspect-[16/7] rounded-xl overflow-hidden mb-6 -mx-4 md:-mx-6" data-id="element-51">
                <img src="https://cdn.magicpatterns.com/uploads/gZKoAMLvFDnizFDyURvF3i/WhatsApp_Image_2026-04-14_at_16.23.43.jpg" alt="El Matambrito VGG" className="w-full h-full object-cover" data-id="element-52" />
              </div>

              <div className="inline-flex items-center gap-2 bg-matambrito-gold/20 text-matambrito-gold px-4 py-1.5 rounded-full text-sm font-bold tracking-wider mb-6 border border-matambrito-gold/30" data-id="element-53">
                <span data-id="element-54">⭐</span> SEDE PRINCIPAL
              </div>

              <h3 className="text-3xl md:text-4xl font-serif font-bold text-matambrito-cream mb-8" data-id="element-55">
                El Matambrito VGG
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10" data-id="element-56">
                <div className="space-y-6" data-id="element-57">
                  <div className="flex items-start gap-3" data-id="element-58">
                    <MapPin className="w-6 h-6 text-matambrito-red-fire shrink-0 mt-1" data-id="element-59" />
                    <div data-id="element-60">
                      <p className="font-medium text-matambrito-cream" data-id="element-61">
                        Dirección
                      </p>
                      <p className="text-matambrito-beige/80" data-id="element-62">
                        Av. San Martín 2666
                        <br data-id="element-63" />
                        Villa Gobernador Gálvez, Santa Fe
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-64">
                    <Clock className="w-6 h-6 text-matambrito-gold shrink-0 mt-1" data-id="element-65" />
                    <div data-id="element-66">
                      <p className="font-medium text-matambrito-cream" data-id="element-67">
                        Horarios
                      </p>
                      <p className="text-matambrito-beige/80" data-id="element-68">
                        <strong className="text-matambrito-beige" data-id="element-69">
                          Mediodía:
                        </strong>{' '}
                        Mar a Dom 11:00 a 16:00hs
                        <br data-id="element-70" />
                        <strong className="text-matambrito-beige" data-id="element-71">
                          Noche:
                        </strong>{' '}
                        Lun a Dom 19:00 a 01:00hs
                      </p>
                    </div>
                  </div>
                </div>

                <div data-id="element-72">
                  <p className="font-medium text-matambrito-cream mb-4" data-id="element-73">
                    ¿Qué vas a encontrar acá?
                  </p>
                  <ul className="space-y-3" data-id="element-74">
                    {['Parrilla completa', 'Patio al aire libre', 'Shows y eventos en vivo', 'Barra de tragos', 'Allegra Café & Pastelería', 'Espacio familiar y eventos'].map((feature, idx) => <li key={idx} className="flex items-center gap-2 text-matambrito-beige/90" data-id="element-75">
                        <CheckCircle2 className="w-5 h-5 text-[#25D366]" data-id="element-76" />
                        <span data-id="element-77">{feature}</span>
                      </li>)}
                  </ul>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row flex-wrap gap-4 pt-6 border-t border-white/10" data-id="element-78">
                <a href="https://maps.google.com/?q=Av.+San+Martín+2666,+Villa+Gobernador+Gálvez,+Santa+Fe" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-matambrito-cream px-6 py-3 rounded-md font-medium transition-colors flex-1" data-id="element-79">
                  <Navigation className="w-5 h-5" data-id="element-80" />
                  Cómo Llegar
                </a>
                <a href={whatsappVGG} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-[#25D366]/20 text-[#25D366] hover:bg-[#25D366] hover:text-white border border-[#25D366]/50 px-6 py-3 rounded-md font-medium transition-colors flex-1" data-id="element-81">
                  <MessageCircle className="w-5 h-5" data-id="element-82" />
                  WhatsApp
                </a>
                <a href="#contacto" className="flex items-center justify-center gap-2 bg-matambrito-red-fire hover:bg-matambrito-red-dark text-white px-6 py-3 rounded-md font-medium transition-colors flex-1" data-id="element-83">
                  Reservar Mesa
                </a>
              </div>

              <div className="mt-6 text-center sm:text-left" data-id="element-84">
                <a href="https://instagram.com/elmatambritovgg" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-matambrito-beige hover:text-matambrito-gold transition-colors" data-id="element-85">
                  <Instagram className="w-5 h-5" data-id="element-86" />
                  @elmatambritovgg
                </a>
              </div>
            </div>
          </motion.div>

          {/* Secondary Branch - Rosario */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="lg:col-span-1 bg-transparent rounded-2xl overflow-hidden border border-white/20 hover:border-white/40 transition-colors h-full flex flex-col" data-id="element-87">
            {/* Rosario branch image */}
            <div className="aspect-[16/9] overflow-hidden" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/sRNHqdsqbBBUoUycEDrow2/carrito-rosario.jpg" alt="El Matambrito Rosario - Carrito" className="w-full h-full object-cover" data-id="element-89" />
            </div>

            <div className="p-8 flex flex-col flex-grow" data-id="element-90">
              <h3 className="text-2xl font-serif font-bold text-matambrito-cream mb-2" data-id="element-91">
                El Matambrito Rosario
              </h3>
              <p className="text-matambrito-beige font-light mb-8" data-id="element-92">
                El sabor del Matambrito en formato urbano
              </p>

              <div className="space-y-6 flex-grow mb-8" data-id="element-93">
                <div className="flex items-start gap-3" data-id="element-94">
                  <MapPin className="w-5 h-5 text-matambrito-gold shrink-0 mt-0.5" data-id="element-95" />
                  <p className="text-matambrito-beige/80" data-id="element-96">
                    Zona Pellegrini y Oroño
                    <br data-id="element-97" />
                    Rosario, Santa Fe
                  </p>
                </div>

                <div className="bg-white/5 p-4 rounded-lg border border-white/10" data-id="element-98">
                  <p className="text-sm font-medium text-matambrito-cream mb-2 uppercase tracking-wider" data-id="element-99">
                    Food Truck
                  </p>
                  <p className="text-matambrito-beige/90" data-id="element-100">
                    Food truck — práctico y urbano
                  </p>
                </div>

                <ul className="space-y-3" data-id="element-101">
                  <li className="flex items-center gap-2 text-matambrito-beige/90" data-id="element-102">
                    <CheckCircle2 className="w-4 h-4 text-matambrito-gold" data-id="element-103" />
                    <span data-id="element-104">Sándwiches de parrilla</span>
                  </li>
                  <li className="flex items-center gap-2 text-matambrito-beige/90" data-id="element-105">
                    <CheckCircle2 className="w-4 h-4 text-matambrito-gold" data-id="element-106" />
                    <span data-id="element-107">Ideal para el mediodía en Rosario</span>
                  </li>
                </ul>
              </div>

              <div className="space-y-4" data-id="element-108">
                <a href={whatsappRosario} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-white/10 hover:bg-white/20 text-matambrito-cream px-6 py-3 rounded-md font-medium transition-colors" data-id="element-109">
                  <MessageCircle className="w-5 h-5" data-id="element-110" />
                  Consultar por WhatsApp
                </a>
                <div className="text-center" data-id="element-111">
                  <a href="https://instagram.com/elmatambritoleoymary" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-matambrito-beige/80 hover:text-matambrito-cream transition-colors text-sm" data-id="element-112">
                    <Instagram className="w-4 h-4" data-id="element-113" />
                    @elmatambritoleoymary
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}